export default __webpack_public_path__ + "static/media/exclamation-icon.05fa0861.svg";